import { PhoneFieldProps } from '../phone-field.types';

import { usePhoneFieldEvents } from './use-phone-field.events';
import { usePhoneFieldMeta } from './use-phone-field.meta';
import { usePhoneFieldState } from './use-phone-field.state';

/**
 * Hook responsible for orchestrating all the phone field hooks.
 *
 * It combines the meta, state and events hooks to provide
 * a single source of truth for the phone field component.
 *
 * @param props the full untreated phone field props
 * @returns the combined phone field context
 */
export function usePhoneFieldProvider(props: PhoneFieldProps) {
  const metadata = usePhoneFieldMeta(props);
  const state = usePhoneFieldState(metadata.flagProps);
  const inputProps = usePhoneFieldEvents({
    baseProps: props,
    inputPropsFactory: metadata.inputPropsFactory,
    selectedCountry: state.selectedCountry,
  });

  return {
    state,
    metadata,
    inputProps,
    errorProps: metadata.maybeErrorOrDescriptionProps,
    useSprite: metadata.flagProps.useSprite,
    flagMode: metadata.flagProps.flagMode,
  };
}

export type PhoneFieldContext = ReturnType<typeof usePhoneFieldProvider>;
